module.exports = __webpack_public_path__ + "img/neeli_1.e1deedc1.png";